import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { useDeviceSelector } from 'js/store/hooks';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

import * as Types from '../types';
import { GAME_LAUNCH_METHODS } from '../constants';
import { useGetGameConfig } from './useGetGameConfig';
import { useGetLaunchMethod } from './useGetLaunchMethod';
import { useLaunchWithLimitsVerification } from './useLaunchWithLimitsVerification';

export const useHandleSuccessLogin = () => {
    const dispatch = useDispatch();
    const translate = useTranslations('playtech.mobile.system.');
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const getGameConfig = useGetGameConfig();
    const getLaunchMethod = useGetLaunchMethod();
    const launchWithLimitsVerification = useLaunchWithLimitsVerification();

    return useCallback(({ gameCode, mode, additionalQueryString, ...options }: Types.ILaunchGameData): void => {
        const gameConfig = getGameConfig(gameCode);
        const launchMethod = getLaunchMethod({ gameCode });

        if (!isDesktop || launchMethod !== GAME_LAUNCH_METHODS.REDIRECT_IN_NEW_WINDOW) {
            launchWithLimitsVerification({ gameCode, mode, additionalQueryString, ...options });

            return;
        }

        dispatch(showCommonPopupAction({
            content: translate('games.popup-blocker-with-confirm'),
            buttons: [{
                text: `${translate('button.realPlay')} ${gameConfig?.name}`,
                onClick: () => launchWithLimitsVerification({ gameCode, mode, additionalQueryString, ...options })
            }],
            onClose: () => dispatcher.dispatch('page:refresh')
        }));
    }, [getLaunchMethod, isDesktop, launchWithLimitsVerification, dispatch, getGameConfig, translate]);
};

